'use client';

import {IMGPW} from '@/config';
import {useTranslations} from 'next-intl';
import {FC, useEffect, useState} from 'react';
import BusinessForm from '../../../../../components/google-forms/BusinessForm';
import BusinessCard from '../../components/BusinessCard';
import BusinessHeader from '../../components/BusinessHeader';
import CardsContainer from '../../components/CardsContainer';
import {SuccessModal} from '../../components/SuccessModal';
import Image from 'next/image';

const InPersonEvent: FC = () => {
  const t = useTranslations('business');
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [formType, setFormType] = useState<string | undefined>();

  const onFormSent = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    const element = document.getElementById('form');
    if (!element) {
      return;
    }

    window.scrollTo({
      behavior: 'smooth',
      top: element.offsetTop,
    });
  }, [formType]);

  const showForm = (form: string) => {
    setFormType(form);
  };

  return (
    <div>
      <div className="section-container mt-4">
        <Image
          height={100}
          width={178}
          src={IMGPW + '/WL_for_business.png'}
          alt="Winelivery For Business" />
      </div>
      <BusinessHeader
        title={t('PhysicalEvents.Header.Title')}
        subtitle={t('PhysicalEvents.Header.Subtitle')}
        paragraph={t('PhysicalEvents.Header.Paragraph')}
        imgSrc={`${IMGPW}/business/evento-in-presenza.jpg`}
      />
      <div className="h-full">
        <CardsContainer>
          <BusinessCard
            imageUrl={`${IMGPW}/business/evento-aziendale.jpg`}
            title={t('PhysicalEvents.Categories.card-1.title-heading')}
            paragraph={t('PhysicalEvents.Categories.card-1.paragraph')}
            url={'eventi-aziendali'}
            onPress={showForm}
            imageMaxHeight={300}
          />
          <BusinessCard
            imageUrl={`${IMGPW}/business/team-building.jpeg`}
            title={t('PhysicalEvents.Categories.card-2.title-heading')}
            paragraph={t('PhysicalEvents.Categories.card-2.paragraph')}
            url="team-building-aziendale"
            onPress={showForm}
            imageMaxHeight={300}
          />

          <BusinessCard
            imageUrl={`${IMGPW}/business/catering-aziendale.jpg`}
            title={t('PhysicalEvents.Categories.card-3.title-heading')}
            paragraph={t('PhysicalEvents.Categories.card-3.paragraph')}
            url="catering-aziendale"
            onPress={showForm}
            imageMaxHeight={300}
          />
        </CardsContainer>

        {formType && (
          <div className="section-container my-12" id="form">
            <BusinessForm
              formType={formType}
              section="in-person"
              onSent={onFormSent}
            />
          </div>
        )}
      </div>
      <SuccessModal isOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  );
};

export default InPersonEvent;
